import "../styles/footer.css";

const Footer = () => {
  return (
    <footer id="main-footer">
      <p>&copy; kuriakm</p>
    </footer>
  );
};

export default Footer;
